/**
 * video-lazy.js — chargement differe des videos autoplay hors du premier ecran.
 *
 * Probleme resolu : une balise <video autoplay> telecharge son fichier des le
 * chargement de la page, meme en preload="metadata" (l'autoplay prime sur le
 * preload). Sur la PDP configurable cela representait 15,5 Mo tires avant meme
 * que le visiteur ne descende.
 *
 * Usage : sur la balise <video>, poser data-lazy-video et deplacer les
 * attributs src des <source> vers data-src. La video est chargee puis lancee
 * quand elle approche du viewport (marge de 300px).
 *
 * Les videos du premier ecran (heros) ne doivent PAS porter data-lazy-video :
 * elles sont visibles immediatement et sont souvent l'element LCP.
 */
(function () {
  'use strict';

  function loadVideo(video) {
    if (video.dataset.lazyLoaded) return;
    video.dataset.lazyLoaded = '1';

    var sources = video.querySelectorAll('source[data-src]');
    for (var i = 0; i < sources.length; i++) {
      sources[i].setAttribute('src', sources[i].getAttribute('data-src'));
      sources[i].removeAttribute('data-src');
    }

    if (video.dataset.src) {
      video.setAttribute('src', video.dataset.src);
      video.removeAttribute('data-src');
    }

    video.load();

    // autoplay ne se redeclenche pas seul apres un load() tardif.
    if (video.hasAttribute('autoplay')) {
      var played = video.play();
      // iOS refuse l'autoplay en mode economie d'energie, et Safari le refuse aussi
      // quand l'economiseur de donnees est actif. Le poster reste alors affiche
      // (section-hero-homepage.js ne revele la video que sur l'evenement 'playing'),
      // et on rearme une tentative au premier geste du visiteur : un play() issu
      // d'une interaction reste autorise, meme en mode economie d'energie.
      if (played && typeof played.catch === 'function') {
        played.catch(function () {
          reessayerApresGeste(video);
        });
      }
    }
  }

  /**
   * Relance la lecture au premier geste du visiteur, apres un autoplay refuse.
   * Les ecouteurs ne sont retires qu'une fois la lecture effectivement obtenue :
   * un geste peut survenir alors que le systeme refuse encore.
   */
  function reessayerApresGeste(video) {
    // touchend et click sont les vrais gestes d'activation au sens HTML (ni
    // touchstart ni pointerdown au doigt) : sans eux, la relance n'etait peut-etre
    // jamais autorisee sur iPhone. scroll reste : mesure utile en WebKit (14/10/2026).
    var evenements = ['touchstart', 'touchend', 'pointerdown', 'click', 'keydown', 'scroll'];

    function retirer() {
      for (var i = 0; i < evenements.length; i++) {
        document.removeEventListener(evenements[i], tenter);
      }
    }

    function tenter() {
      var p = video.play();
      if (p && typeof p.then === 'function') {
        p.then(retirer, function () {});
      } else {
        retirer();
      }
    }

    for (var i = 0; i < evenements.length; i++) {
      document.addEventListener(evenements[i], tenter, { passive: true });
    }
  }

  /**
   * Appelle fn(video) une fois le poster (fond CSS du parent de la video) enregistre
   * comme entree LCP. Sans API LCP (Safari, Firefox) : au load. Filet de securite a
   * 3 s si le poster n'est jamais retenu (autre element plus grand, onglet masque).
   */
  function apresPoster(video, fn) {
    apresElementLcp(video.parentNode, function () { fn(video); });
  }

  function apresElementLcp(poster, fn) {
    var fait = false;
    function lancer() {
      if (fait) return;
      fait = true;
      if (obs) obs.disconnect();
      fn();
    }
    var obs = null;
    var supporte = window.PerformanceObserver && PerformanceObserver.supportedEntryTypes &&
      PerformanceObserver.supportedEntryTypes.indexOf('largest-contentful-paint') !== -1;
    if (supporte) {
      obs = new PerformanceObserver(function (list) {
        var entries = list.getEntries();
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].element === poster) return lancer();
        }
      });
      obs.observe({ type: 'largest-contentful-paint', buffered: true });
      setTimeout(lancer, 3000);
    } else if (document.readyState === 'complete') {
      lancer();
    } else {
      window.addEventListener('load', lancer, { once: true });
    }
  }

  var mqReduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function economieDonnees() {
    var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    return !!(c && c.saveData);
  }

  /**
   * Charge une video de fond avec une source allegee dediee (mobile ou paysage).
   *
   * url vient de data-video-mobile-src ou de data-video-landscape-src. Les <source>
   * desktop sont retirees d'abord : sans cela loadVideo() injecterait aussi leurs
   * data-src et le navigateur pourrait retenir le fichier lourd.
   */
  /**
   * URL de la version allegee ('Mobile' ou 'Landscape') : AV1 puis HEVC si le
   * navigateur les lit et que le markup les fournit, sinon le MP4 H.264. Meme ordre
   * que les <source> desktop, la ou le navigateur choisirait seul (24/10/2026).
   */
  function sourceAllegee(video, format) {
    var d = video.dataset;
    var av1 = d['video' + format + 'Av1Src'];
    var hevc = d['video' + format + 'HevcSrc'];
    if (av1 && video.canPlayType('video/mp4; codecs="av01.0.05M.08"')) return av1;
    if (hevc && video.canPlayType('video/mp4; codecs="hvc1"')) return hevc;
    return d['video' + format + 'Src'];
  }

  function loadVideoAllegee(video, url) {
    if (video.dataset.lazyLoaded) return;

    var sources = video.querySelectorAll('source[data-src], source[src]');
    for (var i = 0; i < sources.length; i++) {
      sources[i].parentNode.removeChild(sources[i]);
    }
    video.dataset.src = url;
    loadVideo(video);
  }

  /**
   * Videos de fond des heros (attribut data-video-desktop).
   *
   * Au dessus de 768px : les <source> du markup, en pleine definition, chargees
   * tout de suite (sauf telephone couche, voir plus bas).
   *
   * En dessous : rien par defaut, car une video d'ambiance en autoplay coute
   * plusieurs Mo de data et de la batterie pour un apport visuel faible. Si
   * data-video-mobile-src est present, la video est autorisee sur mobile MAIS avec
   * ce fichier allege, et seulement une fois le poster enregistre comme element
   * LCP (apresPoster : au load sans API LCP, filet de 3 s), pour que PageSpeed ne
   * compte pas son poids dans le LCP simule.
   *
   * Si data-video-landscape-src est present, un ecran en paysage trop bas pour
   * etre un ordinateur (moins de 500px de haut : telephone couche, y compris les
   * grands iPhone qui depassent 768px de large) recoit cette version 16:9 allegee
   * au lieu du fichier desktop (9,5 Mo sur la home) ou de la version portrait, qui
   * serait tres agrandie dans un cadre paysage. Constat A4 de la relecture du
   * 14/10/2026. Sans cet attribut, comportement d'avant.
   *
   * On s'abstient dans tous les cas si le visiteur demande moins d'animations ou
   * a active l'economie de donnees. Le poster reste alors affiche : la degradation
   * est visuellement propre.
   */
  function initDesktopVideos() {
    var videos = document.querySelectorAll('video[data-video-desktop]');
    if (!videos.length) return;

    var mqLarge = window.matchMedia('(min-width: 768px)');
    var mqBas = window.matchMedia('(max-height: 499px)');
    var mqPaysage = window.matchMedia('(orientation: landscape)');

    function evaluer() {
      if (mqReduced.matches || economieDonnees()) return;

      for (var i = 0; i < videos.length; i++) {
        var video = videos[i];
        var paysage = video.dataset.videoLandscapeSrc;
        if (mqLarge.matches && !(paysage && mqBas.matches)) {
          loadVideo(video);
        } else if (paysage && mqPaysage.matches) {
          // Meme report apres le LCP du poster que la version portrait ci-dessous.
          apresPoster(video, function (v) { loadVideoAllegee(v, sourceAllegee(v, 'Landscape')); });
        } else if (!mqLarge.matches && video.dataset.videoMobileSrc) {
          // Chargement IMMEDIAT, et non differe : mesure du 3 septembre 2026.
          // Une video de fond qui couvre le hero devient le candidat LCP a la place
          // du poster, et Chrome n'ecarte pas les <video> couvrant le viewport comme
          // il ecarte les images (verifie : la regle 101dvh n'a rien change). Le LCP
          // vaut donc le moment ou la video est peinte : la differer le repousse
          // d'autant. Differee apres load + idle, elle donnait 15,6 s de LCP dont
          // 1728 ms de seule attente. La charger tot est le seul levier restant,
          // avec le poids du fichier.
          //
          // REVU le 13/10/2026 : la video est desormais 4px plus courte que le poster
          // (section-hero-homepage.css), elle n'est donc plus candidate LCP. On attend
          // alors que Chrome ait enregistre le poster comme LCP avant de la demander :
          // PageSpeed simule le LCP en rejouant, sous bridage, toutes les requetes
          // parties avant le LCP observe. Demandee avant, ses 818 Ko y comptaient et
          // donnaient 10,8 s de LCP simule, alors que le terrain (CrUX) mesure 1,7 s.
          apresPoster(video, function (v) { loadVideoAllegee(v, sourceAllegee(v, 'Mobile')); });
        }
      }
    }

    evaluer();

    // Rotation ou fenetre redimensionnee : on charge alors la video si aucune ne
    // l'a ete (loadVideo ne recharge jamais une video deja chargee).
    var mqs = [mqLarge, mqBas, mqPaysage];
    for (var k = 0; k < mqs.length; k++) {
      if (typeof mqs[k].addEventListener === 'function') {
        mqs[k].addEventListener('change', evaluer);
      } else if (typeof mqs[k].addListener === 'function') {
        mqs[k].addListener(evaluer);
      }
    }
  }

  /**
   * Medias sous le hero de la home marques data-defer (13/10/2026) : leurs URL
   * attendent dans data-defer-src / -srcset / -poster / -href et ne sont posees
   * qu'une fois le poster du hero enregistre comme LCP. Raison : Chrome charge les
   * images lazy situees a moins de ~1250px du viewport, donc des le debut, et
   * PageSpeed comptait ces ~360 Ko dans son LCP simule. Une fois posees, le
   * comportement est celui d'origine (loading="lazy" compris). Sans hero sur la
   * page, pose immediate.
   */
  function initDeferred() {
    var els = document.querySelectorAll('[data-defer]');
    if (!els.length) return;
    function poser() {
      var attrs = ['srcset', 'src', 'poster', 'href'];
      for (var i = 0; i < els.length; i++) {
        for (var j = 0; j < attrs.length; j++) {
          var v = els[i].getAttribute('data-defer-' + attrs[j]);
          if (v) els[i].setAttribute(attrs[j], v);
        }
        els[i].removeAttribute('data-defer');
      }
    }
    var poster = document.querySelector('.hero-homepage__video-bg');
    if (poster) apresElementLcp(poster, poser); else poser();
  }

  /**
   * Met en pause une video d'ambiance (data-lazy-ambient) qui s'eloigne de l'ecran,
   * et la relance a son retour. Meme marge que le chargement : la video demarre a
   * 300px du viewport et s'arrete au-dela, sans quoi une boucle chargee a
   * l'approche tournerait sans fin si le visiteur rebrousse chemin avant de la voir.
   * Observateur distinct de celui du chargement, qui se desabonne apres le load().
   */
  function initPauseHorsEcran(videos) {
    var ambiance = [];
    for (var i = 0; i < videos.length; i++) {
      if (videos[i].hasAttribute('data-lazy-ambient')) ambiance.push(videos[i]);
    }
    if (!ambiance.length) return;

    var obs = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var video = entries[i].target;
          if (!video.dataset.lazyLoaded) continue;
          if (entries[i].isIntersecting) {
            var p = video.play();
            if (p && typeof p.catch === 'function') p.catch(function () {});
          } else if (!video.paused) {
            video.pause();
          }
        }
      },
      { rootMargin: '300px 0px' }
    );
    for (var j = 0; j < ambiance.length; j++) obs.observe(ambiance[j]);
  }

  function init() {
    initDeferred();
    initDesktopVideos();

    // Videos d'ambiance (data-lazy-ambient, en plus de data-lazy-video) : memes
    // garde-fous que les heros, rien n'est charge si le visiteur demande moins
    // d'animations ou a active l'economie de donnees (le poster pose par
    // initDeferred reste). Les videos produit, dont les vues 3D, n'ont pas cet
    // attribut et ne sont pas concernees. Constat C2 de la relecture du 14/10/2026.
    var ambianceRefusee = mqReduced.matches || economieDonnees();
    var videos = Array.prototype.filter.call(
      document.querySelectorAll('video[data-lazy-video]'),
      function (v) { return !(ambianceRefusee && v.hasAttribute('data-lazy-ambient')); }
    );
    if (!videos.length) return;

    // Sans IntersectionObserver (navigateurs anciens), on charge tout :
    // comportement d'avant, aucune regression.
    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < videos.length; i++) loadVideo(videos[i]);
      return;
    }

    initPauseHorsEcran(videos);

    var observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            loadVideo(entries[i].target);
            observer.unobserve(entries[i].target);
          }
        }
      },
      { rootMargin: '300px 0px' }
    );

    for (var j = 0; j < videos.length; j++) observer.observe(videos[j]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
